(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.ListeningSources = exportFn();
        });

    }

    // NOTE: for listening, RivalIQ uses a slightly modified set of sources than what the Quid API uses.
    // For companion mode, our listening app will use the original Quid API sources defined in the `Quid`
    // object below, while the RivalIQ app will use the `RivalIQ` object below.
    function exportFn() {

        const RivalIQSources = {
            Blogs: {
                id: 'Blogs',
                name: 'Blogs',
                description: `Sites like the Mommy Blog, Kotaku, Gizmodo, Gawker, or LiveJournal`
            },
            Comments: {
                id: 'Comments',
                name: 'Blog/article comments',
                description: `Comments on blogs and news articles`
            },
            Forums: {
                id: 'Forums',
                name: 'Forums',
                description: `Sites like Reddit, parenting forums, eBay forums, BabyCenter, Gaia Online, CafeMom, or InvisionFree`
            },
            News: {
                id: 'News',
                name: 'News',
                description: `Sites like the New York Times or PR Newswire. News sources do not include author name or demographics.`
            },
            ProfReviews: {
                id: 'ProfReviews',
                name: 'Professional reviews',
                description: `Sites like CNET or PCWorld`
            },
            Twitter: {
                id: 'Twitter',
                name: 'Twitter',
                description: `A sample of tweets`
            },
            YouTube: {
                id: 'YouTube',
                name: 'YouTube',
                description: `A sample of videos from YouTube. Results include comments on videos.`
            },
            Other: {
                id: 'Other',
                name: 'Other',
                description: `Other selected sources around the web`
            }
        };

        // This list is from https://help.quid.com/en/articles/8230144-sources-parameter
        const QuidSources = {
            Blogs: {
                id: 'Blogs',
                name: 'Blogs',
                description: `Sites like the Mommy Blog, Kotaku, Gizmodo, Gawker, or LiveJournal.`
            },
            Comments: {
                id: 'Comments',
                name: 'Comments',
                description: `People's opinions attached to posts.`
            },
            ConsumerReviews: {
                id: 'ConsumerReviews',
                name: 'Consumer Reviews',
                description: `Sites like Expedia, Yelp, Amazon or Glassdoor.`
            },
            Facebook: {
                id: 'Facebook',
                name: 'Facebook',
                description: `Facebook`
            },
            Forums: {
                id: 'Forums',
                name: 'Forums',
                description: `Sites like Reddit, Parenting Forums, eBay Forums, BabyCenter, Reddit, Gaia Online, CafeMom, or InvisionFree.`
            },
            Instagram: {
                id: 'Instagram',
                name: 'Instagram',
                description: `Instagram`
            },
            Microblogs: {
                id: 'Microblogs',
                name: 'Microblogs',
                description: `Sites like StatusNet. NOTE: A microblog post typically contains significantly less content than a blog post. Microblog posts, also called microposts, enable users to exchange small content elements, such as short sentences, individual images, or video links.`
            },
            News: {
                id: 'News',
                name: 'News',
                description: `The New York Times or PR Newswire.`
            },
            Other: {
                id: 'Other',
                name: 'Other',
                description: `Sites like Pandora or Netflix. NOTE: The Other category includes corporate, government, education, and other miscellaneous sources.`
            },
            ProfReviews: {
                id: 'ProfReviews',
                name: 'Professional reviews',
                description: `Sites like CNET or PCWorld.`
            },
            SocialNetworks: {
                id: 'SocialNetworks',
                name: 'Social Networks',
                description: `Only content from the following sites: LinkedIn, Google, and VK (for VK subscribers).`
            },
            Twitter: {
                id: 'Twitter',
                name: 'Twitter',
                description: `Twitter`
            },
            YouTube: {
                id: 'YouTube',
                name: 'YouTube',
                description: `YouTube`
            },
            Internal: {
                id: 'Internal',
                name: 'Internal',
                description: `Internal data that Quid Monitor has indexed for your organization as part of the Data Uploader program.`
            }
        };

        return {
            RivalIQSources,
            QuidSources
        };
    }
})();
